(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mirv-ugc-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRoot(root) {
    if (root.dataset.ugcInit) return;
    root.dataset.ugcInit = '1';

    var stage = root.querySelector('[data-ugc-track]');
    if (!stage) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ugc-card]'));
    var n = cards.length;
    if (!n) return;

    var soundOn = false;
    var active = 0;
    var advanceTimer = null;

    function videoAt(i) { return cards[i] ? cards[i].querySelector('video') : null; }
    function cardWidth() { return cards[0].offsetWidth || 240; }
    function getRange() { return window.innerWidth >= 1100 ? 2 : 1; }

    function layout() {
      var W = stage.clientWidth || 0;
      var range = getRange();
      var spacing = Math.min(W / (2 * range + 1), cardWidth() * 1.6);
      for (var i = 0; i < n; i++) {
        var rel = i - active;
        if (rel > n / 2) rel -= n;
        if (rel < -n / 2) rel += n;
        var abs = Math.abs(rel);
        var card = cards[i];
        if (abs > range) {
          card.style.setProperty('--ugc-x', (rel < 0 ? -1 : 1) * (range + 1) * spacing + 'px');
          card.style.setProperty('--ugc-s', '0.6');
          card.style.setProperty('--ugc-o', '0');
          card.style.setProperty('--ugc-pe', 'none');
          card.style.setProperty('--ugc-z', '0');
          card.classList.remove('is-active');
        } else {
          var s = rel === 0 ? 1 : Math.max(0.72, 1 - 0.15 * abs);
          card.style.setProperty('--ugc-x', (rel * spacing) + 'px');
          card.style.setProperty('--ugc-s', s.toFixed(3));
          card.style.setProperty('--ugc-o', '1');
          card.style.setProperty('--ugc-pe', 'auto');
          card.style.setProperty('--ugc-z', String(100 - abs));
          card.classList.toggle('is-active', rel === 0);
        }
      }
    }

    function applySound() {
      root.classList.toggle('is-sound-on', soundOn);
      var v = videoAt(active);
      if (v) v.muted = !soundOn;
    }

    function setActive(i) {
      active = ((i % n) + n) % n;
      layout();
      clearTimeout(advanceTimer);
      for (var j = 0; j < n; j++) {
        var v = videoAt(j);
        if (!v) continue;
        if (j === active) {
          v.muted = !soundOn;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
          v.muted = true;
        }
      }
      if (!videoAt(active)) {
        advanceTimer = setTimeout(function () { setActive(active + 1); }, 4000);
      }
    }

    function next() { setActive(active + 1); }
    function prev() { setActive(active - 1); }

    var prevBtn = root.querySelector('[data-ugc-prev]');
    var nextBtn = root.querySelector('[data-ugc-next]');
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    var muteButtons = root.querySelectorAll('[data-ugc-mute]');
    for (var m = 0; m < muteButtons.length; m++) {
      muteButtons[m].addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        soundOn = !soundOn;
        applySound();
      });
    }

    cards.forEach(function (card, i) {
      card.addEventListener('click', function () { if (i !== active) setActive(i); });
      var v = card.querySelector('video');
      if (v) v.addEventListener('ended', function () { if (i === active) next(); });
    });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(layout, 150);
    });

    requestAnimationFrame(function () { setActive(0); });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-ugc-root]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-masonry-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Convert the flat cards <ul> into a paginated carousel. Reads
  // per-breakpoint columns + rows from data-* attributes on the root.
  function initRoot(root) {
    if (root.dataset.rmgInit) return;
    root.dataset.rmgInit = '1';

    var sourceList = root.querySelector('[data-rmg-cards]');
    var shell = root.querySelector('[data-rmg-viewport-shell]');
    var viewport = root.querySelector('[data-rmg-viewport]');
    var track = root.querySelector('[data-rmg-track]');
    if (!sourceList || !shell || !viewport || !track) return;

    var cards = Array.prototype.slice.call(sourceList.children);
    if (!cards.length) return;

    var cfg = {
      cols: { d: +root.dataset.rmgColsD || 5, t: +root.dataset.rmgColsT || 3, m: +root.dataset.rmgColsM || 1 },
      rows: { d: +root.dataset.rmgRowsD || 2, t: +root.dataset.rmgRowsT || 2, m: +root.dataset.rmgRowsM || 1 },
      autoplay: root.dataset.rmgAutoplay === '1',
      autoSpeed: Math.max(1000, +root.dataset.rmgAutoSpeed || 6000),
      loop: root.dataset.rmgLoop === '1',
      swipe: root.dataset.rmgSwipe === '1'
    };

    var prevBtn = root.querySelector('[data-rmg-prev]');
    var nextBtn = root.querySelector('[data-rmg-next]');
    var dotsRoot = root.querySelector('[data-rmg-dots]');

    var slides = [];
    var current = 0;
    var autoTimer = null;
    var pendingFrame = null;

    function bp() {
      if (window.innerWidth <= 640) return 'm';
      if (window.innerWidth <= 1024) return 't';
      return 'd';
    }
    function colsFor() { return Math.max(1, cfg.cols[bp()]); }
    function rowsFor() { return Math.max(1, cfg.rows[bp()]); }
    function perSlide() { return colsFor() * rowsFor(); }

    function buildSlides() {
      // Move every card back into the source list before redistributing,
      // so we can rebuild on resize without losing nodes.
      cards.forEach(function (c) {
        if (c.parentNode !== sourceList) sourceList.appendChild(c);
      });
      track.innerHTML = '';
      slides = [];

      var per = perSlide();
      var cols = colsFor();
      var total = Math.ceil(cards.length / per);

      for (var s = 0; s < total; s++) {
        var slide = document.createElement('div');
        slide.className = 'rmg-slide';
        slide.style.setProperty('--rmg-slide-cols', cols);
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', 'Slide ' + (s + 1) + ' of ' + total);
        var start = s * per;
        var end = Math.min(start + per, cards.length);
        for (var i = start; i < end; i++) {
          slide.appendChild(cards[i]);
        }
        track.appendChild(slide);
        slides.push(slide);
      }

      buildDots();
      current = Math.min(current, Math.max(0, slides.length - 1));

      // If everything fits in one slide, hide controls entirely.
      var single = slides.length <= 1;
      root.classList.toggle('is-single-slide', single);
      var controls = root.querySelector('[data-rmg-controls]');
      var sideArrows = root.querySelectorAll('.rmg-arrow--side');
      var headerArrows = root.querySelectorAll('.rmg-head .rmg-arrow');
      if (controls) controls.style.display = single ? 'none' : '';
      for (var sa = 0; sa < sideArrows.length; sa++) sideArrows[sa].style.display = single ? 'none' : '';
      for (var ha = 0; ha < headerArrows.length; ha++) headerArrows[ha].style.display = single ? 'none' : '';

      goTo(current, false);
    }

    function buildDots() {
      if (!dotsRoot) return;
      dotsRoot.innerHTML = '';
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rmg-dot' + (i === 0 ? ' is-active' : '');
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        b.addEventListener('click', function () { goTo(i, true); });
        dotsRoot.appendChild(b);
      });
    }

    function setTransition(animate) {
      track.style.transition = animate ? '' : 'none';
    }

    function applyAriaState() {
      slides.forEach(function (s, i) {
        s.setAttribute('aria-hidden', i === current ? 'false' : 'true');
      });
      if (dotsRoot) {
        Array.prototype.forEach.call(dotsRoot.children, function (d, i) {
          d.classList.toggle('is-active', i === current);
          d.setAttribute('aria-selected', i === current ? 'true' : 'false');
        });
      }
      if (!cfg.loop) {
        if (prevBtn) prevBtn.disabled = current === 0;
        if (nextBtn) nextBtn.disabled = current === slides.length - 1;
      } else {
        if (prevBtn) prevBtn.disabled = false;
        if (nextBtn) nextBtn.disabled = false;
      }
    }

    function goTo(i, animate) {
      if (!slides.length) return;
      var n = slides.length;
      if (cfg.loop) i = ((i % n) + n) % n;
      else i = Math.max(0, Math.min(n - 1, i));
      current = i;
      setTransition(!!animate);
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      applyAriaState();
      resetAutoplay();
    }
    function next() { goTo(current + 1, true); }
    function prev() { goTo(current - 1, true); }

    function startAutoplay() {
      if (!cfg.autoplay || slides.length <= 1) return;
      stopAutoplay();
      autoTimer = window.setInterval(next, cfg.autoSpeed);
    }
    function stopAutoplay() {
      if (autoTimer) { window.clearInterval(autoTimer); autoTimer = null; }
    }
    function resetAutoplay() { if (cfg.autoplay) startAutoplay(); }

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    // Keyboard navigation while focus is inside the carousel
    viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
      else if (e.key === 'Home') { e.preventDefault(); goTo(0, true); }
      else if (e.key === 'End') { e.preventDefault(); goTo(slides.length - 1, true); }
    });

    // Pause autoplay on hover/focus
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', resetAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', resetAutoplay);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay(); else resetAutoplay();
    });

    // Touch / swipe (mobile only by default; enabled-elsewhere too)
    if (cfg.swipe) {
      var startX = 0, startY = 0, dx = 0, dy = 0, swiping = false;
      viewport.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        dx = 0; dy = 0; swiping = true;
        stopAutoplay();
      }, { passive: true });
      viewport.addEventListener('touchmove', function (e) {
        if (!swiping) return;
        dx = e.touches[0].clientX - startX;
        dy = e.touches[0].clientY - startY;
      }, { passive: true });
      viewport.addEventListener('touchend', function () {
        if (!swiping) return;
        swiping = false;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) next(); else prev();
        } else {
          resetAutoplay();
        }
      });
    }

    // Rebuild when breakpoint changes
    var lastBp = bp();
    function onResize() {
      if (pendingFrame) cancelAnimationFrame(pendingFrame);
      pendingFrame = requestAnimationFrame(function () {
        if (bp() !== lastBp) {
          lastBp = bp();
          buildSlides();
          startAutoplay();
        }
      });
    }
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);

    // Mark root as enhanced (hides the fallback grid + reveals carousel)
    root.classList.add('is-enhanced');

    buildSlides();
    startAutoplay();

    // Sticky product card visibility + dismiss
    var sticky = root.querySelector('[data-rmg-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          root.classList.toggle('is-sticky-active', e.isIntersecting);
        });
      }, { threshold: 0.05 });
      io.observe(root);
    }
    var stickyClose = root.querySelector('[data-rmg-sticky-close]');
    if (stickyClose) {
      stickyClose.addEventListener('click', function () {
        root.classList.add('is-sticky-dismissed');
      });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-rmg-root]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
